import '@caresend/types';
import { isEncryptedDataValid } from '@caresend/utils';

const removeEncryptedPatientID = (booking) => {
    const patientID = !!booking.patientID
        && typeof booking.patientID !== 'string'
        && isEncryptedDataValid(booking.patientID) ? ''
        : booking.patientID;
    return {
        ...booking,
        patientID,
    };
};

export { removeEncryptedPatientID };
